import React from 'react'

import {Grid, withStyles} from '@material-ui/core'
import ImportantButton from '../../../../shared/components/ImportantButton'
import styles from './styles'
/**
 * These are the buttons that are displayed at the bottom of the Offline Payment Feedback page.
 *
 * @param classes: {Object} containing the JSS classes for the current component to use.
 * @param formData: {Object} containing form data.
 */
const PmcVoucherButtons = ({classes, formData}) => (
  <Grid container justify={"center"}>
    <Grid item xs={12} className={classes.finalizePmcButtonGrid}>
      <a href={formData.successUrl} className={classes.finalizePmc}>
        <ImportantButton>
            Volver al Comercio
        </ImportantButton>
      </a>
    </Grid>

</Grid>
)

const Styled = withStyles(styles)(PmcVoucherButtons)

export default Styled
